var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddSelfie(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 54,
    viewBox: "0 0 56 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Add user"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 33",
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-1 0 0 1 34 1)",
    stroke: "url(#paint0_linear_346_513)",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 2",
    d: "M1 41.3186C1 39.6282 2.06268 38.1202 3.65465 37.5517L10.9009 34.9637C18.0783 32.4004 25.9217 32.4004 33.0991 34.9637L40.3454 37.5517C41.9373 38.1202 43 39.6282 43 41.3186V51.1938C43 52.4108 41.9221 53.3458 40.7172 53.1737L25.8184 51.0453C23.2857 50.6834 20.7144 50.6834 18.1816 51.0453L3.28285 53.1737C2.07798 53.3458 1 52.4109 1 51.1938V41.3186Z",
    stroke: "url(#paint1_linear_346_513)",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line",
    d: "M43 25H55",
    stroke: "url(#paint2_linear_346_513)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_2",
    d: "M49 18.9997L49 30.9998",
    stroke: "url(#paint3_linear_346_513)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_346_513",
    x1: 24,
    y1: 12.2182,
    x2: 1.94257e-8,
    y2: 12.2182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003CF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002AB0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_346_513",
    x1: 43,
    y1: 42.4543,
    x2: 1,
    y2: 42.4543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003CF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002AB0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_346_513",
    x1: 43,
    y1: 24.4909,
    x2: 55,
    y2: 24.4909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003CF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002AB0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_346_513",
    x1: 49.5091,
    y1: 18.9997,
    x2: 49.5091,
    y2: 30.9998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003CF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002AB0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddSelfie);
export default __webpack_public_path__ + "static/media/add-selfie.acaf88560f92415411bd49d1da6ab41e.svg";
export { ForwardRef as ReactComponent };